import { createGlobalStyle } from "styled-components";

export const ProfileStyle = createGlobalStyle`
.unbind {
  path {
    fill: rgba(255, 255, 255, 0.44);
  }
}
.profile-page-wrapper {
  display: flex;
  width: 100%;
  align-items: flex-start !important;
  > .ant-space-item:first-child {
    align-self: stretch;
  }
  > .ant-space-item:last-child {
    width: 100%;
    height: 100%;
  }
  .vertical {
    width: 100%;
  }
  > .ant-space-item:nth-child(2) {
    flex-grow:1;
  }
}
`;
